const position = {
    namespaced: true,

    // state
    state: {
        position: {}
    },

// getters
    getters: {
        position: state => {
            return state.position
        }
    },

// mutations
    mutations: {
        SET_POSITION (state, payload) {
            state.position = payload
        }
    },

// actions
    actions: {
        setPosition ({ commit }, payload) {
            commit('SET_POSITION', payload)
        }
    }

}

export default position
